import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from '@/common/util'
import Layout from './views/layout'
import pcEnter from './views/pcEnter'
import mEnter from './m/mEnter'
import Home from './views/Home.vue'
import Hello from './components/HelloI18n.vue'

Vue.use(Router)
const pcRoutes = [ // pc
  {
    path: '/',
    component: Layout,
    children: [
      { path: '/', name: 'home', component: Home },
      { path: '/page/1', name: 'page1', component: () => import(/* webpackChunkName: "page1" */ './views/page/page1.vue') },
      { path: '/page/2', name: 'page2', component: () => import(/* webpackChunkName: "page2" */ './views/page/page2.vue') },
      { path: '/page/3', name: 'page3', component: () => import(/* webpackChunkName: "page3" */ './views/page/page3.vue') },
      { path: '/page/4', name: 'page4', component: () => import(/* webpackChunkName: "page4" */ './views/page/page4.vue') },
      { path: '/page/5', name: 'page5', component: () => import(/* webpackChunkName: "page5" */ './views/page/page5.vue') },
      { path: '/page/6', name: 'page6', component: () => import(/* webpackChunkName: "page6" */ './views/page/page6.vue') }
    ]
  }, {
    path: '/hello',
    name: 'hello',
    component: Hello
  }
]
const mRoutes = [
  {
    path: '/m',
    name: 'mHome',
    component: () => import(/* webpackChunkName: "home" */ './m/views/home.vue')
  },
  {
    path: '/m/brand',
    name: 'mBrand',
    component: () => import(/* webpackChunkName: "brand" */ './m/views/brand.vue')
  },
  {
    path: '/m/brandInfo/:id',
    name: 'mBrandInfo',
    component: () => import(/* webpackChunkName: "brand_info" */ './m/views/brand_info.vue')
  },
  {
    path: '/m/project',
    name: 'mProject',
    component: () => import(/* webpackChunkName: "project" */ './m/views/project.vue')
  },
  {
    path: '/m/projectInfo/:id',
    name: 'mProjectInfo',
    component: () => import(/* webpackChunkName: "project_info" */ './m/views/project_info.vue')
  },
  {
    path: '/m/service',
    name: 'mService',
    component: () => import(/* webpackChunkName: "service" */ './m/views/service.vue')
  },
  {
    path: '/m/progress',
    name: 'mProgress',
    component: () => import(/* webpackChunkName: "progress" */ './m/views/progress.vue')
  },
  {
    path: '/m/partner',
    name: 'mPartner',
    component: () => import(/* webpackChunkName: "partner" */ './m/views/partner.vue')
  },
  {
    path: '/m/join',
    name: 'mJoin',
    component: () => import(/* webpackChunkName: "join" */ './m/views/join.vue')
  }
]
const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      component: pcEnter,
      children: pcRoutes
    },
    {
      path: '/m',
      name: 'mEnter',
      component: mEnter,
      children: mRoutes
    }
  ]
})
router.beforeEach((to, from, next) => {
  let isM = isMobile() // 是否移动端
  const reg = new RegExp(/^\/m(?:\/(?=$))?$/i)
  const isMPage = reg.test(to.matched[0].path) // 是否移动端页
  if ((isM && isMPage) || (!isM && !isMPage)) {
    next()
  } else if (isM && !isMPage) {
    next({ path: '/m' })
  } else {
    next({ path: '/' })
  }
})

export default router
